<template>
  <v-card class="ma-2">
    <v-card-title v-if="formType == 'sat'">¿Cómo resolvemos un aviso de servicio técnico?</v-card-title>
    <v-card-title v-if="formType != 'sat'">¿Cómo resolvemos una incidencia de transporte?</v-card-title>
    <v-card-text>
      <ol v-if="formType == 'sat'">
        <li>
          Recibido el formulario nuestro equipo técnico se pondrá en contacto con usted si necesate consultarle algo
          sobre la incidencia.
        </li>
        <li>
          Se emite una confirmación de pedido del recambio solicitado por usted. Es necesaria su conformidad para
          proceder al envío.
        </li>
        <li>
          Si la solicitud es en garantía, dependiendo del caso, podremos solicitar que envié por sus medios en menos de
          15 días naturales el recambio supuestamente defectuoso para su análisis por nuestro equipo ténico, y valorar
          si procede garantía.
        </li>
        <li>
          Si procede garantía se enviará factura del recambio con 100% de descuento tanto en su valor como el coste del
          transporte.
        </li>
        <li>
          Si NO procede garantía se explicará por escrito el motivo por el que no se acepta. Se emita factura de venta
          del coste del recambio y el coste del transporte para su pago según su forma de pago estándar.
        </li>
        <li>
          Si no se recibe el recambio supuestamente defectuoso consideramos NO VÁLIDO el proceso de garantía y por tanto
          se procederá de igual manera que en el punto 5
        </li>

      </ol>

      <ol v-if="formType != 'sat'">
        <b><li>
          Si decide una compensación económica le enviaremos una propuesta de la misma. Si acepta, se le enviará un albarán de abono inmediatamente. De este modo se cerrará 
          la incidencia y no será posible cualquier tipo de reclamación posterior.
        </li>
        <li>
          Si quiere uno en perfecto estado, se tramitará el nuevo envío como un pedido completamente nuevo. Una vez recibamos el conforme de recogida por el transporte del 
          producto golpeado se emitirá el abono correspondiente de ese nuevo envío para compensar su cuenta.
        </li>
        <li>
          Si su forma de pago es anticipada tendremos que esperar a recibir el conforme de recogida del producto golpeado por parte de nuestro transporte para realizar un nuevo envío. 
          O bien realizar un nuevo pedido con posterior abono del mismo después de recibir el conforme de recogida.
        </li></b>

      </ol>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "HowTo",
  props: ["formType"],
}
</script>

<style scoped>

</style>